import { render, staticRenderFns } from "./ColorsMapsEditModal.vue?vue&type=template&id=15830e22&scoped=true&"
import script from "./ColorsMapsEditModal.vue?vue&type=script&lang=js&"
export * from "./ColorsMapsEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ColorsMapsEditModal.vue?vue&type=style&index=0&id=15830e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15830e22",
  null
  
)

export default component.exports